import { Autocomplete, Box, Button, Checkbox, Grid, Switch } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from "react-redux";
import { closeDialog } from "../../../redux/reducers/dialogDispositivo-reducer";
import { useDispatch } from "react-redux";
import { useEffect, useState, Fragment } from "react";
import { changeDevices, getDispositiviById, EnableDisableDispositivo } from "../../../const/CardDati";
import axios from "axios";
import { reloadingDataTable } from "../../../redux/reducers/dataTableDispositivi-reducer";
import { useFormik } from "formik";
import * as yup from "yup";
import { dialogAdd, dialogEdit, dialogButtonGeneral, dialogButtonConfirm, changeStatusDeviceDialog, changeStatusDeviceTitleDialog } from "../../../const/DialogData"
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";


const urlBase = process.env.REACT_APP_URL;

const validationSchema = yup.object({
  IdUtente: yup
  .string()
  .required("Campo Obbligatorio"),
  Denominazione: yup
  .string()
  .required("Campo Obbligatorio"),
});

const DialogCustom = () => {

  const stateTypeCall = useSelector(state => state.typeCall)
  const [isRenderingDialog, setIsRenderingDialog] = useState(false);  
  const [changedRow, setchangedRow] = useState();
  const [changedStateDevice, setChangedStateDevice] = useState();
  const dialogState = useSelector((state) => state.dialogDispositivo);
  const [isCallSelectOpen, setIsCallSelectOpen] = useState(false);
  const [selectedCallTypes, setSelectedCallTypes] = useState([]);
  const [inputCallSelect, setInputCallSelect] = useState('');
  const dispatch = useDispatch();
  const {rowInfo, dialogType} = dialogState;
  

  let initialValues = {};
  const {
    id,
    idUtente:IdUtente,
    denominazione: Denominazione,
    abilitaRecuperoChiamatePreInstallazione,
    tipiChiamataUtente,
    dispositivoAbilitato,
  } = rowInfo;

  if (dialogType == "edit") {
    initialValues = {
      IdUtente,
      Denominazione,
      abilitaRecuperoChiamatePreInstallazione,
      tipiChiamataUtente,
      dispositivoAbilitato,
    };
  } else {
    initialValues = {
      IdUtente: "",
      Denominazione: "",
      abilitaRecuperoChiamatePreInstallazione: false,
      tipiChiamataUtente: [],
      dispositivoAbilitato: true,
    };
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true, // rinizializza il valore che gli viene passato con rowInfo
    onSubmit: (values) => {
      setchangedRow({
        ...rowInfo,
        idUtente: values.IdUtente,
        denominazione: values.Denominazione,
        abilitaRecuperoChiamatePreInstallazione:
        values.abilitaRecuperoChiamatePreInstallazione,
        tipiChiamataUtente: values.tipiChiamataUtente,
        dispositivoAbilitato: values.dispositivoAbilitato,
      });
    },
  });


  const handleChangeCallSelect = (event, value) => {
    setSelectedCallTypes(value);
  };

  const handleInputChangeCallSelect = (event, value) => {
    setInputCallSelect(value);
  };


  useEffect(() => {
    if (dialogState.isOpen && dialogType == "edit") {
      (async () => {
        setIsRenderingDialog(true)
        const { action, method } = getDispositiviById;
        let url = urlBase + action + id;
        try {
          const response = await axios({
            method: method,
            url,
          });
          if (response.data.ok) {
            dispatch(reloadingDataTable());
            Object.keys(response.data.result).map((key) => {
              let keyUp = key.charAt(0).toUpperCase() + key.slice(1);
                if(typeof response.data.result[key] !== "string") {
                 formik.setFieldValue(`${[key]}`, response.data.result[key],true)
                }
                if(keyUp === "TipiChiamateAbilitate") {
                  setSelectedCallTypes( response.data.result[key])
                }

             formik.setFieldValue(`${[keyUp]}`, `${response.data.result[key]}`,true)
              })
              setIsRenderingDialog(false)
          } else {
          dispatch(notificationOpen({message:response.data.message,status:response.data.ok }))          
          }
        } catch(error){
          console.error(error);
          if (error.response) {
            dispatch(notificationOpen({message:`${error.response.data.message}`, status:error.ok }))
          } else {
            dispatch(notificationOpen({message:"Operazione fallita: Server non raggiungibile.", status:false }))
          }
        }
        setIsRenderingDialog(false)
      })();
    }
  }, [dialogState.isOpen]);
  
  const closeForm = () => {
  formik.resetForm(initialValues)
  dispatch(closeDialog())
}

  const change = (rowInfo) => {
    if (dialogState.dialogType == "delete") {
      setChangedStateDevice(
       rowInfo.id
      );
      dispatch(closeDialog());
    }
    return changedRow;
  };

  useEffect(() => {
    if (changedRow != null) {
      (async () => {
        
        const listIdType = selectedCallTypes.map(idType => idType.id)
        let changedRowWithType = {...changedRow, tipiChiamataUtente:listIdType}
        
        const { action, method } = changeDevices;
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: changedRowWithType,
          });
          if (response.data.ok) {
            dispatch(reloadingDataTable());
            dispatch(closeDialog())
          } 
          dispatch(notificationOpen({message:response.data.message,status:response.data.ok }))          
        } catch(error){
          console.error(error);
          if (error?.response?.data?.errors != undefined ){
            let keys = Object.keys(error?.response?.data?.errors)
            keys.map(key => {
              formik.setFieldError(key,error?.response?.data?.errors[key] )
            })
          }
        }
      })();
    }
  }, [changedRow]);


  useEffect(() => {
    if (changedStateDevice != null) {
      (async () => {
        let id = changedStateDevice
        
        const { action, method } = EnableDisableDispositivo   
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: id,
            headers:{
              "content-type":"application/json"
            }
          });
          if (response.data.ok) {
            dispatch(reloadingDataTable());
            dispatch(closeDialog())
            setChangedStateDevice(null)
          } 
          dispatch(notificationOpen({message:response.data.message,status:response.data.ok }))          
        } catch(error){
          console.error(error);
          if (error?.response?.data?.errors != undefined ){
            let keys = Object.keys(error?.response?.data?.errors)
            keys.map(key => {
              formik.setFieldError(key,error?.response?.data?.errors[key] )
            })
          }
        }
      })();
    }
  }, [changedStateDevice]);

  useEffect(() => {
    setSelectedCallTypes([]);
  }, [dialogState.isOpen]);


  return (
    <>
      {dialogState.dialogType == "delete" ? (
        <>
          <Dialog
            open={dialogState.isOpen}
            onClose={() => closeForm()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
            {changeStatusDeviceTitleDialog(dispositivoAbilitato)}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              {changeStatusDeviceDialog(dispositivoAbilitato)} il dispositivo <b>{Denominazione}</b> (ID: <b>{IdUtente}</b>) ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => dispatch(closeDialog())}>
              {dialogButtonConfirm.Cancel}
                </Button>
              <Button onClick={() => change(rowInfo)} autoFocus>
              {dialogButtonConfirm.Confirm}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
  !isRenderingDialog ?
        <>
          <Dialog
            open={dialogState.isOpen}
            onClose={() => closeForm()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle >{dialogState.dialogType === "edit" ? dialogEdit.DialogTitle : dialogAdd.DialogTitle }</DialogTitle>
            <DialogContent>
              <form onSubmit={formik.handleSubmit}>
                <FormControl fullWidth>
              <Grid container rowSpacing={1} columnSpacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="IdUtente"
                    label="ID Dispositivo"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={formik.values.IdUtente}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.IdUtente && Boolean(formik.errors.IdUtente)
                    }
                    helperText={
                      formik.touched.IdUtente && formik.errors.IdUtente
                    }
                  />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="Denominazione"
                    label="Denominazione"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={formik.values.Denominazione}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.Denominazione &&
                      Boolean(formik.errors.Denominazione)
                    }
                    helperText={
                      formik.touched.Denominazione &&
                      formik.errors.Denominazione
                    }
                  />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                  <Autocomplete
                      multiple
                      id="tipiChiamataUtente"
                      size="small"
                      open={isCallSelectOpen}
                      onOpen={() => {
                        setIsCallSelectOpen(true);
                      }}
                      onClose={() => {
                        setIsCallSelectOpen(false);
                      }}
                      options={stateTypeCall}
                      value={selectedCallTypes}
                      disableCloseOnSelect
                      limitTags={1}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => option.descrizione}
                      onChange={handleChangeCallSelect}
                      onInputChange={handleInputChangeCallSelect}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.descrizione}
                        </li>
                      )}
                      renderInput={(params) =>  (
                          <TextField {...params} label="Tipologia Chiamata" variant="standard" InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <Fragment>
                                {params.InputProps.endAdornment}
                              </Fragment>
                            )
                          }}
                        />)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                  <FormLabel sx={{mt: 1, display:"block"}}>Recupero pregresso all'installazione</FormLabel>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={formik.handleChange(
                          "abilitaRecuperoChiamatePreInstallazione"
                        )}
                        checked={
                          formik.values.abilitaRecuperoChiamatePreInstallazione
                        }
                      />
                    }
                    label={
                      formik.values.abilitaRecuperoChiamatePreInstallazione ===
                      true
                        ? <Box sx={{padding:"0 32px 0 0", display:"inline"}}>Verranno Salvate le chiamate precedenti alla prima installazione.</Box>
                        : "Non verranno salvate le chiamate precedenti alla prima installazione."
                    }
                  />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                  <FormLabel sx={{mt: 1, display:"block"}}>Dispositivo Abilitato</FormLabel>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={formik.handleChange("dispositivoAbilitato")}
                        checked={formik.values.dispositivoAbilitato}
                      />
                    }
                    label={
                      formik.values.dispositivoAbilitato === true
                        ? "Autorizzato a registrare le chiamate "
                        : "Non autorizzato a registrare le chiamate"
                    }
                  />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                <DialogActions>
                <Button onClick={() => closeForm()}>
                  {dialogButtonGeneral.Cancel}
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => change(rowInfo)}
                    autoFocus
                    >
                    {dialogButtonGeneral.Confirm}
                  </Button>
                </DialogActions>
                </Grid>   
               </Grid>   
              </FormControl>
              </form>
            </DialogContent>
          </Dialog>
        </>
        :
        <></>
      )}
    </>
  );
};

export default DialogCustom;
